/*
 * Filename: cq-template-list.tsx
 */

import React, { useState, BaseSyntheticEvent } from 'react';
import './cq-templates.css';
import { CQStoreManager } from '../../store/store-manager';
import { Utility } from '../../common/utility';

const DeployedTemplateListModal = (props: { templateList: any[], closeDeployedTemplateModal: () => void, onDeployedTemplateSelection: Function }) => {
    const storeManager = new CQStoreManager();
    const [searchTerm, setSearchTerm] = React.useState('');
    const [templateList, filterTemplateList] = useState(props.templateList);
    const utility: Utility = new Utility();

    const searchTermChanged = (e: BaseSyntheticEvent) => {
        setSearchTerm(e.target.value);
    };


    React.useEffect(() => {
        const filteredTemplateList = props.templateList.filter((template: any) => {
            let displayText;
            const { template: templateName, prefixName, suffixName, objectApiName, selectedObject } = template;
            if(template.template.includes('cqGridGenerator')){
                displayText = generateDisplayText(templateName, prefixName, suffixName, objectApiName);
            }else{
                displayText = generateDisplayText(templateName, prefixName, suffixName, selectedObject);
            }
            
            return displayText.toLowerCase().includes(searchTerm.toLowerCase());
        });
        filterTemplateList(filteredTemplateList);
    }, [searchTerm]);

    const deployedTemplate = (template: any) => {
        if(template.hideSaveAndNew === "" && template.showFile === ""){
            template.hideSaveAndNew = false;
            template.showFile = false;
        }
        storeManager.storeDeployedTemplate(template);
        props.onDeployedTemplateSelection(template);
    }

    const generateDisplayText = (templateName: string, prefix: string, suffix: string, objectApiName: string) : string => {
        let labelText = `${templateName} : CQUI`;
        if(prefix){
            labelText = `${labelText} ${prefix.trim()}`;
        }

        labelText = `${labelText} ${utility.generateLabel(objectApiName)}`;

        if(suffix){
            labelText = `${labelText} ${suffix.trim()}`;
        }

        if(templateName.includes('cqGridGenerator')){
            labelText = `${labelText} Grid`;
        }

        labelText = `${labelText} (${objectApiName})`;

        return labelText;
    }

    return (
        <>
            <section role="dialog" className="slds-modal slds-fade-in-open slds-modal"
                aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1">
                <div className="slds-modal__container">
                    <header className="slds-modal__header">
                        <button className="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" onClick={props.closeDeployedTemplateModal} title="Close">
                            <i className="cq-icon-close"></i>
                        </button>
                        <h2 className="slds-text-heading_medium slds-hyphenate">Deployed Components</h2>
                    </header>
                    <div className="slds-modal__content" id="modal-content-id-1">
                        <div className="slds-grid slds-grid_vertical full-height">
                            <div className="slds-theme_shade slds-p-around_medium">
                                <div className="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
                                    <input type="text" className="slds-input slds-combobox__input"
                                        autoComplete="off" role="textbox" placeholder="Search Salesforce"
                                        value={searchTerm}
                                        onChange={searchTermChanged} />
                                    <span className="slds-icon_container slds-icon-utility-search slds-input__icon slds-input__icon_right">
                                        <i className="cq-2x cq-icon-search"></i>
                                    </span>
                                </div>
                            </div>
                            <ul className="slds-grid slds-grid_vertical slds-scrollable slds-grow slds-m-around_medium">
                                {
                                    templateList && templateList.map((template: any, index) => {
                                        
                                        if (template.hasOwnProperty('ruleElements')) {
                                            return (
                                                <li key={index} className="slds-media slds-media_center slds-border_bottom slds-p-vertical_xx-small"
                                                    onClick={() => deployedTemplate(template)}>
                                                    <div className="slds-media__figure">
                                                        <i className="cq-icon-connected_apps"></i>
                                                    </div>
                                                    <div className="slds-media__body">
                                                        {
                                                            template.template.includes('cqGridGenerator')
                                                                ?    
                                                            <a className="slds-grid">{generateDisplayText(template.template, template.prefixName, template.suffixName, template.objectApiName)}</a>
                                                                :
                                                            <a className="slds-grid">{generateDisplayText(template.template, template.prefixName, template.suffixName, template.selectedObject)}</a>
                                                        }
                                                        {/* {
                                                            !template.template &&
                                                            <a className="slds-grid">{template.prefixName}({template.layout.metadata.fullName})</a>
                                                        } */}
                                                    </div>
                                                </li>
                                            );
                                        } else {
                                            return null;
                                        }

                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div className="slds-backdrop slds-backdrop_open"></div>
        </>
    );
};

export default DeployedTemplateListModal;